export const BASEURL = "https://cashwyreservice.azurewebsites.net/api";
